import { useFeedbackButtonsContext } from 'pages/ParentHelper/components/Chat/components/Body/components/Answer/components/FeedbackButtons/hooks';
import { Dialog } from 'shared/components/Dialog';

import { DialogPaper } from './components/DialogPaper';
import { FeedbackDislikeDialogForm } from './components/FeedbackDislikeDialogForm';

import type { FC } from 'react';

export const FeedbackDislikeDialog: FC = () => {
  const { open, onClose } = useFeedbackButtonsContext();

  return (
    <Dialog onClose={onClose} open={open} PaperComponent={DialogPaper}>
      <FeedbackDislikeDialogForm />
    </Dialog>
  );
};
